<template>
  <div class="wt-detail-form-buttons-container">
    <div class="wt-detail-form-buttons-title">
      <div class="left">
        <template v-if="!$slots.left">
          <span>{{title}}</span>
        </template>
        <slot v-else name="left"></slot>
      </div>
      <div class="right" v-show="!isRightHidden">
        <div class="wt-section-title-icon" @click="isExpanded = !isExpanded">
          <span>{{isExpanded?'收起':'展开'}}</span>
          <i :class="{'el-icon-caret-right': !isExpanded, 'el-icon-caret-bottom': isExpanded}"></i>
        </div>
      </div>
    </div>
    <div v-show="isExpanded" class="wt-form-inputs-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'wt-detail-blank-section',
  props: ['title', 'isRightHidden'],
  data() {
    return {
      isExpanded: true
    }
  },
  methods: {
  }
}
</script>

<style scoped>
  .wt-detail-form-buttons-container {
    margin-bottom: 20px;
  }

  .wt-detail-form-buttons-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    background-color: rgba(4, 98, 86, 0.47);
    border: 1px solid rgba(0, 144, 136, 1);
  }

  .wt-detail-form-buttons-title .left {
  }

  .wt-detail-form-buttons-title .left span {
    font-size: 14px;
    color: rgba(2, 220, 206, 1);
    line-height: 20px;
    margin-left: 20px;
  }

  .wt-detail-form-buttons-title .right {
    margin-right: 20px;
  }
</style>
